/* templates */
import {default as warningTemp} from './templates/warning.html';
import {default as tourTemp} from './templates/tour.html';
import {default as updatesTemp} from './templates/updatesList.html';
import {default as modelsTemp} from './templates/modelsList.html';
import {default as modelTemp} from './templates/model.html';
import {default as joinTemp} from './templates/join.html';
import {default as trailerTemp} from './templates/trailer.html';
import {default as videoTemp} from './templates/videoContent.html';
import {default as imageTemp} from './templates/imageContent.html';
import {default as tocTemp} from './templates/toc.html';
import {default as twoTwoFiveSevenTemp} from './templates/2257.html';
import {default as privacyTemp} from './templates/privacy.html';
//import {default as affilatesTemp} from './templates/affiliates.html';
//import {default as linksTemp} from './templates/links.html';
import {default as contactTemp} from './templates/contact.html';
import {default as paginationTemp} from './templates/pagination.html';
import {default as ccoSuccessTemp} from './templates/ccoSucc.html';
import {default as ccoDeclinedTemp} from './templates/ccoDec.html';


import * as directiveTemplates from './templates/directives';

export const theme = {
  templates : {
    warningTemp,
    tourTemp,
    updatesTemp,
    modelsTemp,
    modelTemp,
    joinTemp,
    trailerTemp,
    videoTemp,
    imageTemp,
    tocTemp,
    twoTwoFiveSevenTemp,
    privacyTemp,
//    affilatesTemp,
//    linksTemp,
    contactTemp,
    paginationTemp,
    ccoSuccessTemp,
    ccoDeclinedTemp
  },
  directiveOverrides: {
    footerTagline: directiveTemplates.footerTaglineDirectiveTemp,
    menu: directiveTemplates.menuDirectiveTemp,
    tagline: directiveTemplates.taglineDirectiveTemp,
    slider: directiveTemplates.sliderDirectiveTemp,
    videoBlock: directiveTemplates.videoBlockDirectiveTemp,
    modelBlock: directiveTemplates.modelBlockDirectiveTemp,
    comingSoonVideos: directiveTemplates.comingSoonVideosDirectiveTemp,
    footerTemp: directiveTemplates.siteFooterDirectiveTemp
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/core_theme_3/src/index.js
// module id = 67
// module chunks = 0